module.exports = __webpack_public_path__ + "img/new-help.919ea4d7.svg";